module.exports = __webpack_public_path__ + "media/images/prediction/special/nagai/bg_nagai01_bottom-3d14f43366d42b636880bfff5290ff16.jpg";